import axios from 'axios';
import { Effect, RequestResolver } from 'effect';
import * as Url from '../../../api/url';
import { GetTokenError } from './requests';
export const getTokenResolver = (ritzUrl) => {
    return RequestResolver.fromEffect((request) => Effect.tryPromise({
        try: () => axios
            .get(Url.toString({
            base: ritzUrl,
            path: `/${request.tenant}/auth/get-token`,
            query: {},
        }))
            .then(res => res.data),
        catch: error => new GetTokenError(error),
    }));
};
